import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { IS_MODERN_SSR } from '@atlassian/jira-conditional-ssr-render/src/constants.tsx';
import { browserOnlyResourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config, will follow up in correct channels, other expVals are also ignored
import { expVal } from '@atlassian/jira-feature-experiments';
import getData from './get-data/index.tsx';

/**
 * Delete with cleanup of move_forge_data_fetch_to_main_issue_agg
 * forge data is now fetched in the main issue agg query
 * @deprecated
 */
export const issueForgeDataResource = browserOnlyResourceWithCondition(
	() => {
		if (IS_MODERN_SSR) {
			// not "browser only" if FF is on
			return !expVal('issue_view_ssr_perf_m2', 'isEnabled', false);
		}
		return true;
	},
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	createResource<any>({
		type: 'ISSUE_FORGE_DATA',
		getKey: ({ match }) => {
			const issueKey = getIssueKey(match);
			return issueKey || '';
		},
		getData: (...args) => getData(...args),
		isBrowserOnly: true,
	}),
);
